import Parser from 'html-react-parser';
import { FormControl, FormHelperText, InputLabel, Select, MenuItem } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../../../../assets/icons/info-unfilled.svg';
import { Urls } from '../../../../../config/urls';
import l from '../../../../../lang';
import TooltipIcon from '../../../../common/tooltip-icon';
import { getCurrencyFlagCountryCode } from '../utils';

interface PayoutCurrencySelectProps {
  name: string;
  value: string;
  transferCountry: string;
  currencyOptions: Record<string, string>;
  defaultOptionText: string;
  error?: string;
  disabled?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onChange: (currency: string) => void;
}

const renderCurrencyOption = (currency: string, transferCountry: string) => {
  const flagCode = getCurrencyFlagCountryCode(currency, transferCountry);

  return (
    <span className="payout-create__currency-option">
      <img alt="" src={Urls.flags.replace(':code', flagCode)} />
      <span>{currency}</span>
    </span>
  );
};

const PayoutCurrencySelect = ({
  name,
  value,
  transferCountry,
  currencyOptions,
  defaultOptionText,
  error,
  disabled = false,
  onBlur,
  onChange,
}: PayoutCurrencySelectProps) => {
  const options = Object.keys(currencyOptions);

  return (
    <div className="payout-create__field-with-tooltip">
      <FormControl
        fullWidth
        variant="outlined"
        className={`custom-select payout-create__field-with-tooltip__control ${error ? 'Mui-error' : ''}`}
        error={Boolean(error)}
      >
        <InputLabel className="payout-create__currency-select-label" shrink={Boolean(value || defaultOptionText)} htmlFor={`id-select-${name}`}>
          {l('payouts.create.payoutData.selectCurrency')}
        </InputLabel>
        <Select
          label={l('payouts.create.payoutData.selectCurrency')}
          variant="outlined"
          value={value || ''}
          displayEmpty
          disabled={disabled}
          onBlur={onBlur}
          onChange={event => onChange(event.target.value as string)}
          renderValue={selected => {
            if (!selected) {
              return <span className="payout-create__currency-placeholder">{defaultOptionText}</span>;
            }
            return renderCurrencyOption(String(selected), transferCountry);
          }}
          inputProps={{
            name,
            id: `id-select-${name}`,
          }}
          MenuProps={{
            elevation: 0,
            PaperProps: {
              sx: {
                borderRadius: '8px',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                marginTop: '4px',
              },
            },
          }}
        >
          <MenuItem value="" disabled>
            {defaultOptionText}
          </MenuItem>
          {options.map(currency => (
            <MenuItem key={currency} value={currency}>
              {renderCurrencyOption(currency, transferCountry)}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
      <div className="payout-create__field-with-tooltip__icon">
        <TooltipIcon
          placement="bottom-end"
          text={Parser(l('payouts.create.payoutData.selectCurrencyTooltip'))}
          icon={<InfoIcon />}
          reducedPadding
        />
      </div>
    </div>
  );
};

export default PayoutCurrencySelect;
